import React, { useEffect, useRef, useState } from "react";
import ImageEdit from "./edit";
import ThumbnailPreviews from "./previews";
import { useTranslate } from "@tolgee/react";
import { relocatePublishButtons } from "../../utils/uploadMediaFile";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelImageThumbnail,
  clearImageThumbnail,
  updateEditedImagePresets,
  updateEditedImageState,
  updateEditorImagePresets,
  updateLayeredImagePresets,
  updateLayeredImageState,
  updateUploadedImagePresets,
} from "../../../../redux/slices/lomavisCreator/lomavisCreator";
import { lomavisCreatorRootState } from "../../../../pages/lomavisCreator";
import { generateFirebaseUploadUrl } from "../../../../redux/slices/lomavisCreator/utils";
import axios from "axios";
import toast from "react-hot-toast";
import {
  EDITED_IMAGE,
  FULL_EDITOR_IMAGE,
  IMAGE,
  SOURCE_IMAGE,
  THUMBNAIL_IMAGE,
  THUMBNAIL_PREVIEWS,
} from "../../config/constants";
import {
  MAIN_COLOR_CODES,
  PRIMARY_DARK,
  UPLOAD_TYPE_THUMBNAIL,
} from "../../../../config/constants";
import { getImageDimensions } from "../../utils/helpers";
import axiosClient from "../../../../utils/axios";
import { AddImageButton, EditorHeader } from "../sharedComponents";
import EditorTitle from "../commonElements/editorTitle";

const EditPreview = ({
  platform,
  videoUrl,
  handleClose,
  handleCloseNoConfirmation,
  successNotification,
}) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const footerRef = useRef(null);
  const fileInputRef = useRef(null);
  const [rightMargin, setRightMargin] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [startSubmission, setStartSubmission] = useState(false);
  const [triggerFullEditorImage, setTriggerFullEditorImage] = useState(false);

  const location_uuid = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.locationUuid
  );
  const cloud_uuid = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.cloudUuid
  );
  useEffect(() => {
    relocatePublishButtons({
      footerRef: footerRef,
      setRightMargin: setRightMargin,
    });
  }, []);

  const cancelEdits = () => {
    // dispatch(
    //   clearImageThumbnail({
    //     platform,
    //   })
    // );
    handleClose();
  };

  const PreviewImage = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.postData[platform]
  );
  const uploadedImageThumbnail = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[platform].uploadedImageThumbnail
  );

  const editedImageThumbnail = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[platform].editedImageThumbnail
  );

  const layeredImageThumbnail = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[platform].layeredImageThumbnail
  );

  const fullEditorImage = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData[platform].fullEditorImage
  );

  const uploadImages = async (fileObject, asset: string) => {
    const file = fileObject?.file;
    const currentUploadPreset = fileObject?.uploadPresets;
    const file_type = file?.type;
    const fileSizeInBytes = file?.size;

    const dimensions = await getImageDimensions(URL.createObjectURL(file));
    let url;
    let uploadPreset;
    console.log("has upload presets", asset, currentUploadPreset);
    if (currentUploadPreset) {
      uploadPreset = await generateFirebaseUploadUrl(
        {
          content_type: file_type,
          filesize_in_bytes: fileSizeInBytes,
          filename: file.name,
          uuid: currentUploadPreset.uuid,
          location_uuid: location_uuid ? location_uuid : null,
          cloud_uuid: cloud_uuid ? cloud_uuid : null,
          width: dimensions?.width,
          height: dimensions?.height,
          upload_type: UPLOAD_TYPE_THUMBNAIL,
        },
        {},
        () => console.log("error here")
      );

      url = uploadPreset?.url;
    } else {
      if (asset === SOURCE_IMAGE) {
        uploadPreset = await generateFirebaseUploadUrl(
          {
            content_type: file_type,
            filesize_in_bytes: fileSizeInBytes,
            filename: file.name,
            location_uuid: location_uuid ? location_uuid : null,
            cloud_uuid: cloud_uuid ? cloud_uuid : null,
            width: dimensions?.width,
            height: dimensions?.height,
            upload_type: UPLOAD_TYPE_THUMBNAIL,
          },
          { thumbnail_source_image: true },
          () => console.log("error here")
        );

        dispatch(
          updateUploadedImagePresets({
            platform: platform,
            presets: uploadPreset,
          })
        );
      } else if (asset === THUMBNAIL_IMAGE) {
        uploadPreset = await generateFirebaseUploadUrl(
          {
            content_type: file_type,
            filesize_in_bytes: fileSizeInBytes,
            filename: file.name,
            location_uuid: location_uuid ? location_uuid : null,
            cloud_uuid: cloud_uuid ? cloud_uuid : null,
            width: dimensions?.width,
            height: dimensions?.height,
            upload_type: UPLOAD_TYPE_THUMBNAIL,
          },
          { thumbnail_image: true },
          () => console.log("error here")
        );

        dispatch(
          updateLayeredImagePresets({
            platform: platform,
            presets: uploadPreset,
          })
        );
      } else if (asset === FULL_EDITOR_IMAGE) {
        uploadPreset = await generateFirebaseUploadUrl(
          {
            content_type: file_type,
            filesize_in_bytes: fileSizeInBytes,
            filename: file.name,
            location_uuid: location_uuid ? location_uuid : null,
            cloud_uuid: cloud_uuid ? cloud_uuid : null,
            width: dimensions?.width,
            height: dimensions?.height,
            upload_type: UPLOAD_TYPE_THUMBNAIL,
          },
          { thumbnail_processing_image: true },
          () => console.log("error here")
        );

        dispatch(
          updateEditorImagePresets({
            platform: platform,
            presets: uploadPreset,
          })
        );
      } else if (asset === EDITED_IMAGE) {
        uploadPreset = await generateFirebaseUploadUrl(
          {
            content_type: file_type,
            filesize_in_bytes: fileSizeInBytes,
            filename: file.name,
            location_uuid: location_uuid ? location_uuid : null,
            cloud_uuid: cloud_uuid ? cloud_uuid : null,
            width: dimensions?.width,
            height: dimensions?.height,
            upload_type: UPLOAD_TYPE_THUMBNAIL,
          },
          { thumbnail_processing_image: true },
          () => console.log("error here")
        );

        dispatch(
          updateEditedImagePresets({
            platform: platform,
            presets: uploadPreset,
          })
        );
      }
      url = uploadPreset?.url;
    }

    const headers = uploadPreset?.headers; // Example header

    putWithFile(url, file, headers, file_type, asset, uploadPreset, dimensions)
      .then((responseData) => {
        console.log("Upload successful:", responseData);
      })
      .catch((error) => {
        console.error("Upload failed:", error);
      });
  };

  const putWithFile = async (
    url,
    file,
    headers,
    file_type,
    asset,
    uploadPreset,
    dimensions
  ) => {
    setUploading(true);
    try {
      const config = {
        headers: headers ? { ...headers, "Content-Type": file_type } : {}, // Set headers property with provided headers
      };
      const response = await axios.put(url, file, {
        ...config,
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        },
      });
      try {
        const res = await axiosClient.put(uploadPreset?.confirm_url, {
          success: true,
        });
        successNotification();
        console.log("upload confirmation", res.data);
      } catch (err: any) {
        console.log(err);
      }

      setUploading(false);
      if (asset === THUMBNAIL_IMAGE) {
        dispatch(
          updateLayeredImageState({
            platform: platform,

            uploadState: true,
            media: {
              id: `${uploadPreset?.uuid}`,
              uuid: uploadPreset?.uuid,
              name: `${file.name}`,
              file: file,
              preview_image:
                uploadPreset?.uploaded_object_data.preview_image_url,
              orientation: null,
              media_type: IMAGE,
              video_duration: null,
              file_size: file?.size,
              width: dimensions?.width,
              height: dimensions?.height,
              uploadPreset: uploadPreset,
              file_type: file_type,
              assetBlob: null,
              source_media_uuid: null,
              uploaded: true,
              isUploading: false,
              editorUpdateState: false,
              previewImageURL:
                uploadPreset?.uploaded_object_data.preview_image_url,
              thumbnail_image: uploadPreset?.thumbnail_url,
              original_asset: uploadPreset?.uploaded_object_data.original_asset,
              api_url: uploadPreset?.uploaded_object_data?.api_url,
            },
          })
        );
      }
      if (asset === EDITED_IMAGE) {
        dispatch(
          updateEditedImageState({
            platform: platform,

            uploadState: true,
            media: {
              id: `${uploadPreset?.uuid}`,
              uuid: uploadPreset?.uuid,
              name: `${file.name}`,
              file: file,
              preview_image:
                uploadPreset?.uploaded_object_data.preview_image_url,
              orientation: null,
              media_type: IMAGE,
              video_duration: null,
              file_size: file?.size,
              width: dimensions?.width,
              height: dimensions?.height,
              uploadPreset: uploadPreset,
              file_type: file_type,
              assetBlob: null,
              source_media_uuid: null,
              uploaded: true,
              isUploading: false,
              editorUpdateState: false,
              previewImageURL:
                uploadPreset?.uploaded_object_data.preview_image_url,
              thumbnail_image: uploadPreset?.thumbnail_url,
              original_asset:
                uploadPreset?.uploaded_object_data?.original_asset,
              api_url: uploadPreset?.uploaded_object_data?.api_url,
            },
          })
        );
      }

      if (asset === THUMBNAIL_IMAGE) {
        setTriggerFullEditorImage(!triggerFullEditorImage);
      }

      console.log("return data", response);

      return response.data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request canceled:", error.message);
      } else {
        const res = error.response;

        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        console.error(`Looks like there was a problem. Status Code: ${error}`);

        console.error("Error:", error);
        throw error;
      }
      toast.error(` ${t("errors.request_couldnt_be_completed")}`, {
        duration: 4000,
        position: "top-right",
      });

      // Dispatch deleteAfile action inside the catch block

      if (asset === THUMBNAIL_IMAGE) {
        setStartSubmission(false);
        handleCloseNoConfirmation();
      }
    }
  };

  const handleSubmit = async () => {
    setStartSubmission(true);
    // await uploadImages(uploadedImageThumbnail, SOURCE_IMAGE);
    await uploadImages(editedImageThumbnail, EDITED_IMAGE);
    await uploadImages(layeredImageThumbnail, THUMBNAIL_IMAGE).then(() => {
      return;
    });
  };

  useEffect(() => {
    // if (fullEditorImage.uploaded) {
    //   uploadImages(fullEditorImage, FULL_EDITOR_IMAGE);
    // }
  }, [fullEditorImage.uploaded]);

  return (
    <div
      style={{ overflowY: "auto" }}
      className="d-flex flex-column w-100 h-100 position-relative gap-4 "
    >
      <div
        style={{ backgroundColor: startSubmission ? "white" : "" }}
        className="w-100 h-100 d-flex gap-4 justify-content-center rounded-3"
      >
        <div
          style={{
            width: "66%",
            display: startSubmission ? "none" : "flex",
          }}
          className={`h-100 flex-column gap-4`}
        >
          <EditorHeader>
            <EditorTitle title={"edit_thumbnail"} toolTip={false} />

            <div className="">
              <AddImageButton
                handleClick={() => fileInputRef.current?.click()}
                disabled={startSubmission}
              />
            </div>
          </EditorHeader>

          <div
            style={{ overflowY: "hidden" }}
            className="d-flex flex-column gap-3 flex-fill h-100 overflow-hidden bg-white rounded-3"
          >
            <ImageEdit
              platform={platform}
              fileInputRef={fileInputRef}
              setStartSubmission={setStartSubmission}
              handleCloseNoConfirmation={handleCloseNoConfirmation}
              handleClose={handleClose}
              triggerFullEditorImage={triggerFullEditorImage}
            />
          </div>
        </div>

        <div
          style={{ width: startSubmission ? "50%" : "33%", maxWidth: "700px" }}
          className="h-100 d-flex flex-column gap-4 align-items-center "
        >
          {startSubmission && (
            <p
              style={{ fontSize: "24px", fontWeight: "bolder" }}
              className="text-dark w-100 d-flex justify-content-center text-center bg-white rounded-3 p-4"
            >
              {t("lomavisCreator.savingThumbnail")}
            </p>
          )}{" "}
          <ThumbnailPreviews
            startSubmission={startSubmission}
            videoUrl={videoUrl}
            platform={platform}
          />{" "}
        </div>
      </div>{" "}
      <div
        ref={footerRef}
        style={{ bottom: "0", zIndex: 100, height: "60px" }}
        className="w-100 d-flex justify-content-end gap-3 align-items-center bg-white py-2 border-top rounded-3"
      >
        {!startSubmission && (
          <Button onClick={cancelEdits} variant="secondary" size="sm">
            {t("lomavisCreator.cancel")}
          </Button>
        )}
        <Button
          style={{ marginRight: rightMargin + "px" }}
          variant="primary"
          size="sm"
          onClick={() => {
            handleSubmit();
          }}
          disabled={startSubmission}
        >
          {startSubmission && (
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
          )}
          {startSubmission
            ? t("lomavisCreator.buttons.saving")
            : t("lomavisCreator.buttons.save")}
        </Button>
      </div>
      {/* {startSubmission && (
        <div
          style={{
            width: "100%",
            height: "100%",
            zIndex: 120,
            top: "1px",
            left: "1px",

            backgroundColor: "white",
            opacity: 0.3,
          }}
          className="underlay position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
        >
          <p
            style={{ fontSize: "40px", fontWeight: "bolder" }}
            className="text-dark"
          >
            {t("lomavis_creator.saving")}
          </p>
        </div>
      )} */}
    </div>
  );
};

export default EditPreview;
